import { render, staticRenderFns } from "./grantuserinfo.vue?vue&type=template&id=26612641"
import script from "./grantuserinfo.vue?vue&type=script&lang=ts"
export * from "./grantuserinfo.vue?vue&type=script&lang=ts"
import style0 from "./grantuserinfo.vue?vue&type=style&index=0&id=26612641&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports